import React from 'react';
import { observer } from 'mobx-react';
import { TriviaIntroCardWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import { DeckUI } from '@seedlang/state';
import NextButton from 'components/trivia_card/next_button';
import { flexCenterColumn, flexCenter } from '@seedlang/style_mixins';
import Text from 'components/text';
import TriviaCardPlayer from 'components/trivia_card/trivia_card_player';
import PageOnboarding from 'components/onboarding/page_onboarding';
import { pixify } from '@seedlang/utils';
import IntroCardWords from 'components/card/intro_card_words';

const Wrapper = styled.div`
  ${flexCenterColumn()}
  height: ${props => props.height};
  position: relative;
  background: #333;
`;

const Content = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const PlayersRow = styled.div`
  ${flexCenter()}
`;

const Versus = styled.div`
  margin: 0 30px;
  color: white;
`;

const PageOnboardingWrapper = styled.div`
  padding: 0 10px;
`;

@observer
class TriviaIntroCard extends React.Component {

  render() {
    return (
      <Wrapper
        height={pixify(DeckUI.layout.contentHeightWithoutButtons)}
        width={pixify(DeckUI.layout.deckWidth)}
      >
        <Content>
          <Text
            heading='2'
            color='white'
            textAlign='center'
            margin='20px 0'
          >
            PLAY TRIVIA
          </Text>
          <PlayersRow>
            <TriviaCardPlayer
              flexDirection='column'
              nameMargin='5px 0 0 0'
              vertical
              hideProStatus
              user={DeckUI.user}
              nameFontSize='16px'
              userProfileImageWidth={100}
              userProfileBorder='5px solid white'
            />
            {
              this.props.hasOpponent &&
              <Versus>vs</Versus>
            }
            {
              this.props.hasOpponent &&
              <TriviaCardPlayer
                flexDirection='column'
                nameMargin='5px 0 0 0'
                vertical
                hideProStatus
                user={this.props.opponent}
                nameFontSize='16px'
                userProfileImageWidth={100}
                userProfileBorder='5px solid white'
              />
            }
          </PlayersRow>
          {
            this.props.hasOpponent && !DeckUI.user.wasUiElementSeen('trivia-opponent') &&
            <PageOnboardingWrapper>
              <PageOnboarding
                margin='10px 0'
                background='#bfbfbf'
                uiElement='trivia-opponent'
              >
                You are playing vs a previous performance of your opponent. Feel free to <b>take your time between turns</b>. Don't rush and most importantly, have fun!
              </PageOnboarding>
            </PageOnboardingWrapper>
          }
          <IntroCardWords
            deck={DeckUI.deck}
            user={DeckUI.user}
            layout={DeckUI.layout}
          />
        </Content>
        <NextButton
          disabled={!this.props.inView}
          onClick={() => DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard)}
          shortcut='1'
          submitOnEnter
          text='Start Game'
          margin='10px 0'
        />
      </Wrapper>
    );
  }
}

export default TriviaIntroCardWrapper(TriviaIntroCard);
